// Manually record a handled error.
export const recordError = (error: Error): void => {
  console.error('error:', error);
};
